// extracted by mini-css-extract-plugin
export var container = "styles-module__container___DD1QV";
export var typeAndDate = "styles-module__typeAndDate___UNW1V";
export var formSection = "styles-module__formSection___kWwML";
export var textInputSpacer = "styles-module__textInputSpacer____vLRS";
export var labelName = "styles-module__labelName___NrSuP";
export var starRatingIconClass = "styles-module__starRatingIconClass___tUfNx";
export var privacyContainer = "styles-module__privacyContainer___haKar";
export var stars = "styles-module__stars___igs1i";
export var topField = "styles-module__topField___ZxMRs";
export var nearbyTrailsContainer = "styles-module__nearbyTrailsContainer___wFyvd";
export var trailDropdown = "styles-module__trailDropdown___BHDmH";
export var nameAndNotes = "styles-module__nameAndNotes___Orb73";
export var starRatingContainer = "styles-module__starRatingContainer___kTc1_";
export var medium = "styles-module__medium___HmAQo";
export var upload = "styles-module__upload___EcEH0";
export var datePicker = "styles-module__datePicker___W_Lax";
export var nameAndDescription = "styles-module__nameAndDescription___guh0A";
export var textArea = "styles-module__textArea___q5hoA";
export var starsContainer = "styles-module__starsContainer___VI809";
export var formContainer = "styles-module__formContainer___Jg3ic";